import { createFileRoute } from "@tanstack/react-router";
import Navbar from "@/components/Navbar";
import CityHeroShared from "@/components/CityHeroShared";
import CityMap from "@/components/CityMap";
import CityUseCases from "@/components/CityUseCases";
import MobileBookNowFab from "@/components/MobileBookNowFab";
import VehicleTypeIcons from "@/components/VehicleTypeIcons";
import FleetMeatSection, { ReviewsSection } from "@/components/FleetMeatSection";
import SprinterSpecsSection from "@/components/SprinterSpecsSection";
import SeoLongform from "@/components/SeoLongform";
import GeoAnswerBlock from "@/components/GeoAnswerBlock";
import { SAVANNAH_REVIEWS } from "@/data/reviews/savannah";
import { cityHeadMeta } from "@/data/citySeo";

export const Route = createFileRoute("/savannah")({
  component: CityLanding,
  head: () => ({
    meta: [
      ...cityHeadMeta("savannah"),
      { property: "og:image", content: "https://sprinter-van-rentals.com/__l5e/assets-v1/d9d070c6-6676-46c4-b0f4-9b0498e3c905/van-lot-og.jpg" },
      { property: "twitter:image", content: "https://sprinter-van-rentals.com/__l5e/assets-v1/d9d070c6-6676-46c4-b0f4-9b0498e3c905/van-lot-og.jpg" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://sprinter-van-rentals.com/savannah" }],
  }),
});

function CityLanding() {
  return (
    <main className="min-h-screen bg-white text-[#0F172A]">
      <Navbar />
      <MobileBookNowFab />
      <CityHeroShared
        citySlug="savannah"
        cityLabel="Savannah"
        headline={"Savannah\nSprinter Van Rentals"}
        intro="12 and 15 passenger Sprinters in Savannah, luggage room behind the last row, dropped at SAV, Historic District or your door."
      />
<section id="fleet" className="max-w-[1440px] mx-auto px-6 pt-12 md:pt-16 pb-24 scroll-mt-24">
        <div className="mb-10">
          <p className="font-display font-bold text-xs uppercase tracking-[0.4em] mb-3 text-[#F97316]">The Savannah Sprinter Fleet</p>
          <h2 className="font-display font-black text-5xl md:text-6xl tracking-tight text-[#0F172A]">
            Savannah Sprinter van rentals, ready to book.
          </h2>
        </div>
        <VehicleTypeIcons accent="#F97316" citySlug={"savannah" as never} />
      </section>

      <CityMap citySlug={"savannah" as never} accent="#F97316" />
      <ReviewsSection city="savannah" accent="#F97316" dark accentSecondary="#FFB347" reviewCity="Savannah" reviews={SAVANNAH_REVIEWS} />
      <SprinterSpecsSection city="savannah" accent="#F97316" />
      <FleetMeatSection city="savannah" accent="#F97316" dark accentSecondary="#FFB347" reviewCity="Savannah" />
      <SeoLongform citySlug="savannah" />
      <GeoAnswerBlock citySlug="savannah" />
      <CityUseCases citySlug={"savannah" as never} accent="#F97316" />
      <footer className="py-8 text-center border-t border-[#0F172A]/8">
        <p className="text-[#0F172A]/50 text-xs tracking-widest uppercase">&copy; 2026 Sprinter Van Rentals · Savannah</p>
      </footer>
    </main>
  );
}
